import React from 'react';

import { cakeIcon } from '@app/assets';
import { FlyingCookieCoordinateTransition } from '@app/shared/types/flyingCookie';

type FlyingCookieSize = 'sm' | 'md' | 'lg';

interface FlyingCookieProps extends FlyingCookieCoordinateTransition {
  size?: FlyingCookieSize;
}

const SIZE_TO_STYLES_MAP: Record<FlyingCookieSize, string> = {
  sm: 'size-6',
  md: 'size-8',
  lg: 'size-10',
};

export function FlyingCookie({ startX, startY, moveToX, moveToY, size = 'sm' }: FlyingCookieProps) {
  return (
    <div
      className="pointer-events-none fixed z-9999 animate-fly"
      style={
        {
          left: startX,
          top: startY,
          '--move-x': moveToX,
          '--move-y': moveToY,
        } as React.CSSProperties
      }
    >
      <img src={cakeIcon} alt="cookie" className={SIZE_TO_STYLES_MAP[size]} />
    </div>
  );
}
